import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'dmv-pub-sub-footer',
    templateUrl: './sub-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SubFooterComponent {

  public phoneNumber: string = environment.contactInfo.phoneNumber;
  public site: string = environment.contactInfo.site;

}
